export enum CommonQuestionCategoryEnum {
  "Getting Started" = 1,
  "Account & Profile" = 2,
  "Billing & Payments" = 3,
  "Service & Booking" = 4
}

export enum CommonQuestionSortByEnum {
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  likes = "likes",
  views = "views",
  question = "question"
}

export enum CommonQuestionSortOrderEnum {
  asc = "asc",
  desc = "desc"
}
